import { StoreCardForPack } from "../../../components/store-card/store-card-for-pack";
import { StoreCardForTimesailYet } from "../../../components/store-card/store-card-for-timesail-yet";
import {
  getReserveTime,
  getReserveTimeForTomorrow,
} from "../../../utils/reserve-time";
import { canPackExpose, getExposeType } from "../../../utils/store-expose";
import type { Product, Store } from "../../../__generated__/graphql";

interface MapStoreCardProps {
  store: Store | null;
  onStoreClick: (id: number) => void;
}

const MapStoreCard = ({ store, onStoreClick }: MapStoreCardProps) => {
  if (!store) return null;

  const wrapper = (children: React.ReactNode) => (
    <div className="pointer-events-auto absolute bottom-1 z-[60] w-full p-4">
      <div className="shadow-2xl">{children}</div>
    </div>
  );

  if (store.todaysProducts && store.todaysProducts.length !== 0) {
    const products = store.todaysProducts as Product[];
    return wrapper(
      <StoreCardForTimesailYet
        title={store.title as string}
        quantity={products.reduce(
          (total, product) => total + product.quantity,
          0,
        )}
        closingHours={store.closingHours as string}
        discountPrice={products[0]?.userPrice as number}
        price={products[0]?.price}
        disableLike
        img={store.img as string}
        onClick={() => onStoreClick(store.id as number)}
        likeCount={store.likes?.length ?? 0}
        signupDate={store.createdAt}
      />,
    );
  }

  if (store.pack && canPackExpose(store)) {
    return wrapper(
      <StoreCardForPack
        title={store.title}
        quantity={store.pack.currentCount}
        discountPrice={store.pack.userPrice}
        price={store.pack.price}
        distance={store.distance}
        img={store.img as string}
        reserveTime={getReserveTime(
          store.reserveTime as Record<string, { start?: string; end?: string }>,
        )}
        tomorrowReserveTime={getReserveTimeForTomorrow(
          store.reserveTime as Record<string, { start?: string; end?: string }>,
        )}
        onClick={() => onStoreClick(store.id as number)}
        exposeType={getExposeType(store.pack)}
        likeCount={store.likes?.length ?? 0}
        signupDate={store.createdAt}
      />,
    );
  }

  const products = (store.todaysProducts ?? []) as Product[];
  return wrapper(
    <StoreCardForTimesailYet
      title={store.title as string}
      quantity={products.reduce(
        (total, product) => total + product.quantity,
        0,
      )}
      closingHours={store.closingHours as string}
      discountPrice={products[0]?.userPrice as number}
      price={products[0]?.price}
      disableLike
      img={store.img as string}
      onClick={() => onStoreClick(store.id as number)}
      likeCount={store.likes?.length ?? 0}
      signupDate={store.createdAt}
    />,
  );
};

export default MapStoreCard;
